import { ChildRef } from '../../../../../lib/web/components/child-ref';
import { ClickListener } from '../../../../../lib/web/components/click-listener';
import { Component } from '../../../../../lib/web/components/component';
import { ComponentBase } from '../../../../../lib/web/components/component-base';
import { EventListener } from '../../../../../lib/web/components/event-listener';

@Component({
    selector: '.a-check-box'
})
export class CheckBoxComponent extends ComponentBase<HTMLInputElement> {

    @ChildRef('input')
    private _inputElement: HTMLInputElement = null;

    public constructor(node: HTMLInputElement) {
        super(node);
    }

    public onInit(): void {
        (this._node as any).name = this._inputElement.name;
    }

    @EventListener('blur', 'input')
    public onBlur(): void {
        this.dispatchCustomEvent('blur');
    }

    @EventListener('input', 'input')
    public onInput(): void {
        this.dispatchCustomEvent('input');
    }

    public focus(): void {
        this._inputElement.focus();
    }

    public get value(): boolean {
        return this._inputElement.checked;
    }

    public set value(value: boolean) {
        this._inputElement.checked = value;
    }
}